"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styled = require("./styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ContentCountBlock = function ContentCountBlock(_ref) {
  var counts = _ref.counts,
      children = _ref.children,
      inline = _ref.inline;
  var contentCounts = counts.map(function (count) {
    var hasValue = typeof count.value !== 'undefined';
    var hasAction = typeof count.action !== 'undefined';
    return _react["default"].createElement(_styled.ContentCount, {
      inline: inline,
      hasAction: hasAction,
      key: count.text,
      onClick: function onClick() {
        return hasAction && count.action();
      }
    }, _react["default"].createElement(_styled.Label, null, count.text), hasValue ? _react["default"].createElement(_styled.ContentCountValue, {
      inline: inline
    }, count.value || 0) : null, hasAction ? _react["default"].createElement("div", null, count.actionText) : null);
  });
  return _react["default"].createElement(_styled.ContentCountBlockContainer, null, contentCounts, children);
};

var _default = ContentCountBlock;
exports["default"] = _default;

//# sourceMappingURL=ContentCountBlock.js.map